import { render } from "./FileUploader.vue?vue&type=template&id=b3e66fb8&scoped=true"
import script from "./FileUploader.vue?vue&type=script&lang=js"
export * from "./FileUploader.vue?vue&type=script&lang=js"

import "./FileUploader.vue?vue&type=style&index=0&id=b3e66fb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3e66fb8"]])

export default __exports__